// extracted by mini-css-extract-plugin
export default {"textBold":"CommandService__textBold--UwYsFGMJNQqsjaHIc581"};